import * as React from 'react';
import { Pressable, StyleSheet, View, useWindowDimensions } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import Carousel, { ICarouselInstance, Pagination } from 'react-native-reanimated-carousel';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { useGetHighlightsQuery } from 'services/cms';
import { RootState } from 'store/index';

import CarouselItem from './carouselItem';

import { Icons } from 'components/Icons';
import Skeleton from 'components/Skeleton';

const NewCarousel: React.FC<CmsHomeHero> = (props) => {
  const ref = React.useRef<ICarouselInstance>(null);
  const { width: PAGE_WIDTH, height: PAGE_HEIGHT } = useWindowDimensions();
  const progress = useSharedValue<number>(0);
  const profile = useSelector((state: RootState) => state.profile);
  const analytics = useAnalytics();
  const { data, isLoading, refetch } = useGetHighlightsQuery(props?.searchPrograms, {
    pollingInterval: 900000,
  });

  React.useEffect(() => {
    if (!isLoading && data && data.items && data.items.length > 0) {
      const firstItem = data.items[0];
      if (firstItem) {
        // const analyticsPayload = {
        //   promotion_id: firstItem.id || firstItem._id || `banner_index_0`,
        //   promotion_name: firstItem.title || `Banner 1`,
        //   creative_name: firstItem.creative_name || firstItem.image_url,
        //   creative_slot: `slot_1`,
        // };
        // analytics.triggerViewPromotionEvent({
        //   promotionId: analyticsPayload.promotion_id,
        //   promotionName: analyticsPayload.promotion_name,
        //   creativeName: analyticsPayload.creative_name,
        //   creativeSlot: analyticsPayload.creative_slot,
        // });
      }
    }
  }, [isLoading, data, props.id, props.title]);

  const handleSnapToItem = (index: number) => {
    if (data && data.items && data.items[index]) {
      const viewedItem = data.items[index];
      // const analyticsPayload = {
      //   promotion_id: viewedItem.id || viewedItem._id || `banner_index_${index}`,
      //   promotion_name: viewedItem.title || `Banner ${index + 1}`,
      //   creative_name: viewedItem.creative_name || viewedItem.image_url,
      //   creative_slot: `slot_${index + 1}`,
      // };
      // analytics.triggerViewPromotionEvent({
      //   promotionId: analyticsPayload.promotion_id,
      //   promotionName: analyticsPayload.promotion_name,
      //   creativeName: analyticsPayload.creative_name,
      //   creativeSlot: analyticsPayload.creative_slot,
      // });
    }
  };

  const onPressPagination = (index: number) => {
    ref.current?.scrollTo({ index: index, animated: true });
  };
  const onPressToLeft = () => {
    ref.current?.prev();
  };
  const onPressToRight = () => {
    ref.current?.next();
  };

  React.useEffect(() => {
    refetch();
  }, [profile.ageRating]);

  if (isLoading || !data) return <Skeleton variant="hero" />;

  if (!data.items || data.items.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      {PAGE_WIDTH > 500 ? (
        <Carousel
          ref={ref}
          width={PAGE_WIDTH / 1.2}
          loop
          style={{
            zIndex: 999,
            width: PAGE_WIDTH,
            alignItems: 'center',
            justifyContent: 'center',
            height: 650,
            marginBottom: -20,
          }}
          onProgressChange={progress}
          onSnapToItem={handleSnapToItem}
          autoPlay
          autoPlayInterval={10000}
          data={data.items}
          mode="parallax"
          enabled={false}
          modeConfig={{
            parallaxScrollingScale: 0.95,
            parallaxScrollingOffset: 50,
            parallaxAdjacentItemScale: 0.95,
          }}
          renderItem={({ item, index }: any) => (
            <View style={styles.carouselItemContainer}>
              <CarouselItem item={item} index={index} listId={props.id} listName={props.title} />
              <Pagination.Basic
                progress={progress}
                data={data.items}
                dotStyle={styles.desktopDot}
                activeDotStyle={styles.desktopActiveDot}
                containerStyle={styles.desktopPaginationContainer}
                horizontal
                onPress={onPressPagination}
              />
            </View>
          )}
        />
      ) : (
        <View>
          <Carousel
            ref={ref}
            width={PAGE_WIDTH}
            loop
            height={PAGE_HEIGHT < 680 ? (PAGE_HEIGHT < 600 ? 400 : 450) : 550}
            onProgressChange={progress}
            onSnapToItem={handleSnapToItem}
            onConfigurePanGesture={(e) => {
              e.activeOffsetX([-10, 10]);
              e.failOffsetY([-5, 5]);
            }}
            data={data.items}
            renderItem={({ item }: any) => (
              <View style={styles.mobileCarouselItem}>
                <CarouselItem item={item} />
              </View>
            )}
          />
          <Pagination.Basic
            progress={progress}
            data={data.items}
            dotStyle={styles.mobileDot}
            activeDotStyle={styles.mobileActiveDot}
            containerStyle={styles.mobilePaginationContainer}
            horizontal
          />
        </View>
      )}
      {PAGE_WIDTH > 500 && (
        <>
          <Pressable style={styles.leftArrowButton} onPress={onPressToLeft}>
            <Icons.ArrowLeft width="24" height="24" color="#fff" />
          </Pressable>

          <Pressable style={styles.rightArrowButton} onPress={onPressToRight}>
            <Icons.ArrowRight width="24" height="24" color="#fff" />
          </Pressable>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    marginBottom: -30,
  },
  carouselItemContainer: {
    position: 'relative',
    flex: 1,
  },
  desktopDot: {
    borderRadius: 7,
    backgroundColor: 'white',
    width: 14,
    height: 14,
  },
  desktopActiveDot: {
    backgroundColor: '#6386FF',
  },
  desktopPaginationContainer: {
    position: 'absolute',
    top: '90%',
    left: '50%',
    gap: 8,
  },
  mobileCarouselItem: {
    height: '100%',
    width: '100%',
  },
  mobileDot: {
    borderRadius: 6,
    backgroundColor: '#6386FF',
    width: 12,
    height: 12,
  },
  mobileActiveDot: {
    backgroundColor: 'white',
  },
  mobilePaginationContainer: {
    position: 'absolute',
    bottom: 10,
    height: 100,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    width: '100%',
  },
  leftArrowButton: {
    position: 'absolute',
    backgroundColor: 'rgba(7, 13, 49, 0.4)',
    borderWidth: 2,
    borderColor: '#fff',
    borderRadius: 28,
    top: '50%',
    left: '2%',
    height: 56,
    width: 56,
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightArrowButton: {
    position: 'absolute',
    backgroundColor: 'rgba(7, 13, 49, 0.4)',
    borderWidth: 2,
    borderColor: '#fff',
    borderRadius: 28,
    top: '50%',
    right: '2%',
    height: 56,
    width: 56,
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default NewCarousel;
